module.exports = __webpack_public_path__ + "static/media/hospital.8c3e42f0.svg";